/**
 * Подбор и назначение инспектора админом для заказа в SEARCH.
 * Реализуется двумя SECURITY DEFINER RPC из миграции
 * `20260504020000_assign_inspector_rpc.sql` (репо `stryzh`).
 */
import { createClient } from '@/api/supabase'

export interface NearestInspectorRow {
  inspector_id: string
  full_name: string | null
  phone: string | null
  last_position_at: string | null
  /** Расстояние в км до точки заказа (NULL если у инспектора нет позиции). */
  distance_km: number | null
  no_position: boolean
  is_busy: boolean
  busy_order_id: string | null
}

export async function findNearestInspectorsForOrder(
  orderId: string,
  radiusKm: number,
): Promise<NearestInspectorRow[]> {
  const supabase = createClient()
  const { data, error } = await supabase.rpc('find_nearest_inspectors_for_order', {
    p_order_id: orderId,
    p_radius_km: Math.max(1, Math.round(radiusKm)),
  })
  if (error) throw new Error(error.message)
  // PostgREST RPC возвращает array of records.
  return (data ?? []) as NearestInspectorRow[]
}

export type AssignErrorCode =
  | 'forbidden'
  | 'inspector_not_found'
  | 'not_an_active_inspector'
  | 'order_not_in_search'
  | 'inspector_already_busy'
  | 'order_has_no_coordinates'
  | 'unknown'

export class AssignInspectorError extends Error {
  code: AssignErrorCode
  constructor(code: AssignErrorCode, message?: string) {
    super(message ?? code)
    this.code = code
    this.name = 'AssignInspectorError'
  }
}

const KNOWN_CODES: AssignErrorCode[] = [
  'forbidden',
  'inspector_not_found',
  'not_an_active_inspector',
  'order_not_in_search',
  'inspector_already_busy',
  'order_has_no_coordinates',
]

export async function assignInspectorToOrder(
  orderId: string,
  inspectorId: string,
): Promise<void> {
  const supabase = createClient()
  const { error } = await supabase.rpc('assign_inspector_to_order', {
    p_order_id: orderId,
    p_inspector_id: inspectorId,
  })
  if (!error) return
  // RAISE EXCEPTION 'order_not_in_search' приходит как message в PostgrestError.
  const msg = error.message ?? ''
  const code = KNOWN_CODES.find((c) => msg.includes(c)) ?? 'unknown'
  throw new AssignInspectorError(code, msg)
}
